import type { ContactUsForm, ContactUsSuccessResponse } from '@libs/common-node';
import { HttpMethod } from '@libs/core';
import { client } from '../../../client';
import { CWEA_ENDPOINTS } from '../../../constants';

export async function handleContactUs(body: ContactUsForm) {
    try {
        const url = CWEA_ENDPOINTS.customerCare.contactUs;

        const response = await client.cwea<ContactUsSuccessResponse>(`${url}`, {
            method: HttpMethod.POST,
            body: JSON.stringify(body),
        });

        // API response is null when unsuccessful, so we manually set isSuccess to false
        return response || { isSuccess: false };
    } catch (error) {
        return {
            isSuccess: false,
        };
    }
}
